import styles from "./Ecosystem.module.css"
import Banner from "../../components/Banner"
import Header from "../../components/Header"
import Container from "../../components/Container"
import Team from "../../components/Team"
import Footer from "../../components/Footer"
import { motion } from "framer-motion";
import TitlePages from "../../components/TitlePages"
import videoEcosystem from "./video-ecosystem.m4v"

const technologies = [
    "HTML5", "CSS", "JAVASCRIPT", "NEXTJS", "REACT JS", "REST API", "GRAFHQL", "NODE JS", "PYTHON", 
    "EXPRESS JS", "GODOT ENGINE", "PHASER", "MONGODB", "MYSQL", "CLOUD PLATFORMS", "BLOCKCHAINS", 
    "EOS/WAY", "ETHEREUM", "SOLANA", "AVALANCHE", "POLYGON", "BINANCE", "SOLIDITY", "SMARTCONTRACT", "C/C++"
]


function Ecosystem() {
    return(
        <>
            <Header />
            <Banner 
               videoSrc={videoEcosystem}
               title="The ecosystem behind our <br> game <span>development<span>."
               subtitle="Our ecosystem represents the technologies, infrastructure, and <br> resources that support how we build games and digital products — from <br> core development to optional Web3 and blockchain integrations."
            />
            <Container>
                <TitlePages
                    title="Let's build <br/> something <span>amazing</span>."
                    subTitle="Empowering your projects with our ecosystem <br/> of technology and expertise."
                ></TitlePages>

                    <section className={styles.box}>
                        {technologies.map((tech, index) => (
                            <motion.div                                                //div animado do Framer Motion
                                key={index}                                            
                                className={styles.stack}                               
                                initial={{ opacity: 0, y:30 }}                         //Estado inicial(capacidade 0 e levemente pra baixo)
                                whileInView={{ opacity: 1, y: 0 }}                     //Quando ele aparece na tela - fica visivel e sobe pra posição normal
                                transition={{ delay: index * 0.07, duration: 0.4 }}    //Define tempo atraso
                                viewport={{ once: true }}                              //faz a animação acontecer so uma vez, nao toda hora que rolar
                            >
                                <p className={styles.graphic}>{tech}</p>
                            </motion.div>
                        ))}
                    </section>
            </Container>
            <Team />
            <Footer />
        </>
    )
}

export default Ecosystem
